/**
 * Build authenticated media URL using `?auth=` query param.
 * Lets the browser fetch images directly with <img src="..."> and cache them.
 */
import { API, getToken } from "@/lib/api";

export const mediaThumbUrl = (id, size = 600) => {
  const token = getToken();
  return `${API}/media/${id}/thumb?size=${size}&auth=${encodeURIComponent(token || "")}`;
};

export const mediaFileUrl = (id) => {
  const token = getToken();
  return `${API}/media/${id}/file?auth=${encodeURIComponent(token || "")}`;
};

export const musicFileUrl = (id) => {
  const token = getToken();
  return `${API}/music/${id}/file?auth=${encodeURIComponent(token || "")}`;
};
